import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M9,11a.77.77,0,0,1-.75.77H5.75A.77.77,0,0,1,5,11H5a.77.77,0,0,1,.75-.77h2.5A.77.77,0,0,1,9,11Zm4.75-7.72v9.44A1.76,1.76,0,0,1,12,14.5H4a1.76,1.76,0,0,1-1.75-1.78V3.28A1.76,1.76,0,0,1,4,1.5h8A1.76,1.76,0,0,1,13.75,3.28ZM4.45,3A3.68,3.68,0,0,0,6.36,5.56a2,2,0,0,1,3.28,0A3.68,3.68,0,0,0,11.55,3ZM8,5.75a1,1,0,1,0,1,1A1,1,0,0,0,8,5.75Zm4.25-.56A5.22,5.22,0,0,1,10,7.09,2,2,0,0,1,6,7.09a5.22,5.22,0,0,1-2.28-1.9v7.53A.25.25,0,0,0,4,13h8a.25.25,0,0,0,.25-.25Z';
const draw24px =
  'M11.75,18a.76.76,0,0,1-.75.75H7a.75.75,0,0,1,0-1.5h4A.76.76,0,0,1,11.75,18ZM11,14.25H7a.75.75,0,0,0,0,1.5h4a.75.75,0,0,0,0-1.5ZM20.75,5V19A2.75,2.75,0,0,1,18,21.75H6A2.75,2.75,0,0,1,3.25,19V5A2.75,2.75,0,0,1,6,2.25H18A2.75,2.75,0,0,1,20.75,5ZM5.8,3.77a6.23,6.23,0,0,0,3.75,5,2.75,2.75,0,0,1,3.7-1.2,2.68,2.68,0,0,1,1.2,1.2,6.23,6.23,0,0,0,3.75-5l-.2,0H6Zm6.2,5A1.25,1.25,0,1,0,13.25,10,1.25,1.25,0,0,0,12,8.75Zm7.25-3a7.77,7.77,0,0,1-4.51,4.51,2.75,2.75,0,0,1-5.48,0A7.77,7.77,0,0,1,4.75,5.74V19A1.25,1.25,0,0,0,6,20.25H18A1.25,1.25,0,0,0,19.25,19Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const PackageIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'package'),
) as IconWithRender;

PackageIcon.displayName = 'PackageIcon';
PackageIcon.propTypes = Icon.propTypes;
PackageIcon.renderIcon = (props) => <PackageIcon {...props} />;
export default PackageIcon;
